@if (canEditUserGroupSelection() || canEditExternalEmails()) {
  <div class="row g-2 mb-1">
    @if (canEditUserGroupSelection()) {
      <div class="col-12 {{ singleSelection() ? '' : 'col-md-6' }}">
        <div class="d-flex flex-column">
          <span class="text-secondary fw-bold">
            <app-form-label [type]="'content'" [label]="'ADD' + method().toUpperCase() | translate"></app-form-label>
          </span>
          <app-form-dropdown
            [fG]="userGroupMailForm"
            [fCN]="'userGroup'"
            [dataSource]="userGroupOptions"
            [placeholder]="'TYPE' + method().toUpperCase() + 'NAME' | translate"
            [allowFiltering]="true"
            [mapping]="{text: 'name', value: 'id'}"
            [returnObject]="true"
            (reachedEndOfList)="loadNextPage()"
            (search)="search($event)"
            (dropdownClosed)="resetSearchOnClose()"
            (valueChange)="addUserGroup($event)"
            [hasErrorField]="hasErrorField()"
            [errorText]="'TYPE' + method().toUpperCase() + 'NAMEREQUIRED' | translate"
            [cssClass]="hasError() ? 'e-error' : ''">
          </app-form-dropdown>
        </div>
      </div>
    }
    @if (allowEmails() && canEditExternalEmails()) {
      <div class="col-12 col-md-6">
        <div class="d-flex-column">
          <span class="text-secondary fw-bold">
            <app-form-label [type]="'content'" [label]="'EXTERNALMAIL' | translate"></app-form-label>
          </span>
          <app-form-input [fG]="userGroupMailForm" [fCN]="'addMail'" [placeholder]="('EXTERNALMAIL' | translate)" [iconBack]="'add_circle'" [iconClickType]="'back'" (iconBackClick)="addMail()"></app-form-input>
        </div>
      </div>
    }
    @if (showSelectedParticipants() && !singleSelection() && participants.length) {
      <div class="d-flex align-items-center">
        <span class="text-secondary fw-bold">
          <app-form-label [type]="'content'" [label]="'SELECTEDPARTICIPANTS' | translate"></app-form-label>
        </span>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-0">
        <div>
          @if (method() === 'userGroup' && canEditUserGroupSelection()) {
            <app-form-dropdown
              [fG]="userGroupMailForm"
              [fCN]="'userGroupMailFilter'"
              [dataSource]="userGroupMailFilter"
              [placeholder]="'SELECTFILTER' | translate"
              [icon]="'filter_list'"
              [popupWidth]="'auto'"
              [cssClass]="'small-filter-dropdown'">
            </app-form-dropdown>
          }
        </div>
        @if (hasEditableParticipants()) {
          <div class="dropdown">
            <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
              <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              @if(allSelected()) {
                <li><app-link (click)="deselectAll()" [title]="('UNSELECTALL' | translate)" [style]="'dropdown'">{{ ('UNSELECTALL' | translate) }}</app-link></li>
              } @else {
                <li><app-link (click)="selectAll()" [title]="('SELECTALL' | translate)" [style]="'dropdown'">{{ ('SELECTALL' | translate) }}</app-link></li>
              }
              @if (allowPush() && hasPushParticipants() && !externalEmailsOnly()) {
                @if (allPushEnabled()) {
                  <li><app-link (click)="disablePushForAll()" [title]="('DISABLEPUSH' | translate)" [style]="'dropdown'">{{ ('DISABLEPUSH' | translate) }}</app-link></li>
                } @else {
                  <li><app-link (click)="enablePushForAll()" [title]="('ENABLEPUSH' | translate)" [style]="'dropdown'">{{ ('ENABLEPUSH' | translate) }}</app-link></li>
                }
              }
              <li><app-link (click)="removeSelected()" [title]="('REMOVESELECTED' | translate)" [style]="'dropdown'">{{ ('REMOVESELECTED' | translate) }}</app-link></li>
            </ul>
          </div>
        }
      </div>
    }
  </div>
}

@if (showSelectedParticipants() && !singleSelection()) {
  <div class="custom-scrollbar overflow-y-auto">
    @for (participant of participants; track participant) {
      @if (userGroupMailForm.controls['userGroupMailFilter'].value === 'all' || userGroupMailForm.controls['userGroupMailFilter'].value === participant.type) {
        <div class="card selected-user-group mb-2">
          <div class="d-flex align-items-center align-items-stretch">
            @if (canEditParticipant(participant)) {
              <div class="remove-icon-column d-flex align-items-center justify-content-center border-end">
                <app-form-button (click)="showDeleteOverlay(participant)" [cssClass]="'e-link text-muted p-0'" [icon]="'close'"></app-form-button>
              </div>
            }
            <div class="d-flex align-items-center p-1 me-1">
              <app-avatar [image]="participant.image!" [name]="participant.name!" [type]="'small'" [icon]="participant.type === 'user' ? 'person' : participant.type === 'group' ? 'group' : 'mail'" [border]="false"></app-avatar>
            </div>
            <div class="flex-grow-1 lh-1 d-flex align-items-center">
              <app-tooltip [text]="participant.name!" [opensOn]="'Auto'">
                <app-headline [type]="'h6'" [title]="participant.name!" [class]="'text-muted fs-small'"></app-headline>
                @if (participant.type === 'user') {
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' | translate }}</app-content>
                }
                @if (participant.type === 'group') {
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'GROUP' | translate }} - <b>{{ participant.count }}</b> {{ 'USER' | translate }}</app-content>
                }
                @if (participant.type === 'mail') {
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'EXTERNALMAIL' | translate }}</app-content>
                }
              </app-tooltip>
            </div>
            @if (participant.type === 'group' && allowGroupsToResolve() && canEditParticipant(participant)) {
              <div class="resolve-group-column d-flex align-items-center justify-content-center border-start px-2">
                <app-tooltip [text]="'RESOLVEGROUPSTOUSERS' | translate" [opensOn]="'Auto'">
                  <app-form-button (click)="resolveGroupToUsers(participant)" [iconClass]="'fs-5'" [cssClass]="'e-link p-0 text-primary'" [icon]="'group_add'"></app-form-button>
                </app-tooltip>
              </div>
            }
            @if (participant.type !== 'mail' && allowPush() && canEditParticipant(participant)) {
              <div class="push-notification-column d-flex align-items-center justify-content-center border-start px-2">
                <app-tooltip [text]="(participant.push ? 'DISABLEPUSH' : 'ENABLEPUSH') | translate" [opensOn]="'Auto'">
                  <app-form-button (click)="togglePush(participant)" [iconClass]="'fs-5'" [cssClass]="'e-link p-0' + (participant.push ? ' text-primary' : ' text-disabled')" [icon]="participant.push ? 'notifications_active' : 'notifications'"></app-form-button>
                </app-tooltip>
              </div>
            }
            @if (participant.type === 'user' && allowAdmins() && canEditParticipant(participant)) {
              <div class="is-admin-column d-flex align-items-center justify-content-center border-start px-2"><!-- no admin groups allowed for chat -->
                <app-tooltip [text]="(participant.admin ? 'ISNOTADMIN' : 'ISADMIN') | translate" [opensOn]="'Auto'">
                  <app-form-button (click)="toggleAdmin(participant)" [iconClass]="'fs-5'" [cssClass]="'e-link p-0' + (participant.admin ? ' text-primary' : ' text-muted')" [icon]="'shield_person'"></app-form-button>
                </app-tooltip>
              </div>
            }
            @if (participant.type === 'group' && participant.description) {
              <div class="info-column d-flex align-items-center justify-content-center border-start px-2">
                <app-tooltip [text]="participant.description" [opensOn]="'Auto'">
                  <app-form-button [iconClass]="'fs-5'" [cssClass]="'e-link p-0 text-primary cursor-default'" [icon]="'info'"></app-form-button>
                </app-tooltip>
              </div>
            }
            @if (canEditParticipant(participant)) {
              <div class="checkbox-column d-flex align-items-center justify-content-center border-start px-2">
                <app-form-checkbox [fG]="userGroupMailForm" [fCN]="participant.type! + participant.id" [cssClass]="'pb-1'"></app-form-checkbox>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
}
